module.exports = __webpack_public_path__ + "static/media/pendapatan.ca697f66.png";